export default __webpack_public_path__ + "static/media/logo_redirect.f6e02c2b.svg";